import useData from '@hooks/data.hook';

const useOrg = () => {
  return useData('organization', 'primary');
};

export default useOrg;
